import request from "../utils/request";

export const getWorkflows = '/workflow/'

export function modifyWorkflow(data: any) {
    return request.request({
        url: '/workflow/',
        method: 'put',
        data: data
    })
}